export default __webpack_public_path__ + "static/media/castejon.9a1a787b.jpg";